var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total>0)?_c('qx-pagination',{staticClass:"pagination",attrs:{"pager-count":9,"page-size":_vm.pageSize,"page-sizes":_vm.pageSizes,"current-page":_vm.curPage,"total":_vm.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }